export const FAQ_ASK_PATH = "/faq/ask";
export const FAQ_QUESTION_MIN_LENGTH = 8;
export const FAQ_QUESTION_MAX_LENGTH = 300;

export const FAQ_ASK_REFUSALS = [
  "invalid_request",
  "rate_limited",
  "busy",
  "blocked",
] as const;

export type FaqAskRefusal = (typeof FAQ_ASK_REFUSALS)[number];

export type FaqAskSourceLink = { title: string; path: string };

export type FaqAskEvent =
  | { type: "delta"; text: string }
  | { type: "replace"; text: string }
  | {
      type: "done";
      questionId: string;
      isGrounded: boolean;
      sources: FaqAskSourceLink[];
    }
  | { type: "error" };
